// extracted by mini-css-extract-plugin
export default {"samples":"samples-OIvbY","table":"table-k8MQZ"};